export default {
    name: 'combo',
    path: 'combo',
    meta: {
        title: '订单管理'
    },
    component: ()=>import('@/pages/index.vue'),
    children: [
        {
            name: 'combo-version',
            path: 'version',
            meta: { title: '版本套餐' },
            component: ()=>import('@/pages/combo/version.vue')
        },
        {
            name: 'combo-code',
            path: 'code',
            meta: { title: '溯源码套餐' },
            component: ()=>import('@/pages/combo/code.vue')
        },
        {
            name: 'combo-plugin',
            path: 'plugin',
            meta: { title: '插件套餐' },
            component: ()=>import('@/pages/combo/plugin.vue')
        }
    ]
}